import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchSurveyPosApi,
  filterSurveyPosApi,
  fetchSurveyByIdApi,
  submitPosSurveyApi,
} from "../../../api/endpoint";

function* getSurveySaga(action) {
  try {
    const _api = yield call(fetchSurveyPosApi, action.payload);
    yield put(actions.setSurveyInfo(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* filterSurveyPosSaga(action) {
  try {
    const _api = yield call(filterSurveyPosApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setSurveyInfo(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

function* getSurveyPosByIdSaga(action) {
  try {
    const _api = yield call(fetchSurveyByIdApi, action.payload);
    yield put(actions.setSurveyInfoById(..._api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

function* submitPosSurveySaga(action) {
  try {
    const _api = yield call(submitPosSurveyApi, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setRedirect(true));
    }
    // yield put(actions.setSurveyInfoById(..._api.data.results));
    // yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

export function* watchSurveyPosSaga() {
  yield all([
    takeEvery(actionTypes.GET_SURVEY_INFO, getSurveySaga),
    takeEvery(actionTypes.GET_FILTERED_SURVEY, filterSurveyPosSaga),
    takeEvery(actionTypes.GET_SURVEY_POS_BY_ID, getSurveyPosByIdSaga),
    takeEvery(actionTypes.SUBMIT_POS_SURVEY, submitPosSurveySaga),
  ]);
}
